<div class="srIrops-itinerary srIrops-cancelItinerary" style="margin-top: 45px;">
  <div class="srIrops-newItinerary">
    <div class="srIrops-textNewItinerary text-am-white fs-24px fw-regular lh-30px">
      <h3>
        {{ flightNumber }}
      </h3> <!-- "srIrops.itinerary" | translate -->
    </div>
    <div class="srIrops-tagCancelled">
      <div class="text-am-white fs-20px fw-medium-x lh-28px">
        {{ "srIrops.cancelled" | translate }}
      </div>
    </div>
  </div>
  <div class="srIrops-separatorLine" style="height: 100px;"></div>
  <div class="srIrops-routeOriginDestination">
    <div class="srIrops-origin">
      <span class="srIrops-originDate text-am-white fs-24px fw-regular lh-34px opacity-75">
        {{ segment?.departureDateTime | localizedDate:'dd MMM' | lowercase }}
      </span>
      <div class="srIrops-originHour">
        <div class="srIrops-textCancel fs-32px fw-medium-x lh-42px">
          <span>
            {{ segment?.departureDateTime | date:'HH:mm' }}
          </span>
        </div>
      </div>
      <div class="srIrops-originDeparture text-am-white fs-24px fw-regular lh-34px opacity-75">
        <span>
          {{ departureAirport }}
        </span>
      </div>
    </div>
    <img src="../../../../../assets/images/Line_points.svg" alt="">
    <div class="srIrops-destination">
      <span class="srIrops-destinationDate text-am-white fs-24px fw-regular lh-34px opacity-75">
        {{ segment?.arrivalDateTime | localizedDate:'dd MMM' | lowercase }}
      </span>
      <div class="srIrops-destinationHour srIrops-textCancel fs-32px fw-medium-x lh-42px">
        <span>
          {{ segment?.arrivalDateTime | date:'HH:mm' }}
        </span>
      </div>
      <div class="srIrops-destinationDeparture text-am-white fs-24px fw-regular lh-34px opacity-75">
        <span>
          {{ arrivalAirport }}
        </span>
      </div>
    </div>
  </div>
</div>
<banner-irops-rebrand
  copyButtonBanner="srIrops.IropsBannerButtonR"
  [copyTextMain]="changeCopyBanner"
  [showButtonChangeFlight]="false"
  [isCancel]="!!segCancel"
></banner-irops-rebrand>